import { Col, Modal, Row } from 'antd'
import React from 'react'
import { useCwdLang } from './useCwdLang'

export interface CarTypeOption {
  label: string
  sampleModels: string[]
}

export const CAR_TYPES: CarTypeOption[] = [
  { label: 'Economy Sedan', sampleModels: ['Toyota Vios', 'Honda City'] },
  { label: 'Standard Sedan', sampleModels: ['Toyota Camry', 'Honda Accord'] },
  { label: 'Business Class', sampleModels: ['Mercedes C-Class', 'BMW 3 Series'] },
  { label: 'First Class', sampleModels: ['Mercedes S-Class', 'BMW 7 Series'] },
  { label: 'Van', sampleModels: ['Toyota Commuter', 'Mercedes Sprinter'] },
  { label: 'Luxury Van', sampleModels: ['Mercedes V-Class', 'Toyota Alphard'] },
  { label: 'Luxury MPV', sampleModels: ['Toyota Alphard', 'Kia Carnival'] },
  { label: 'SUV', sampleModels: ['Toyota Fortuner', 'Honda CR-V'] },
]

const modalStyles = `
  .cwd-type-modal .ant-modal-content { border-radius: 16px !important; }
  .cwd-type-modal .ant-modal-header { border-radius: 16px 16px 0 0 !important; padding: 16px 20px !important; border-bottom: 1px solid #f0f0f0 !important; }
  .cwd-type-modal .ant-modal-title { font-family: 'Poppins', sans-serif !important; font-weight: 600 !important; }
  .cwd-type-modal .ant-modal-body { padding: 20px !important; }

  .cwd-type-pill { display: flex !important; align-items: center !important; justify-content: center !important; border-radius: 8px !important; cursor: pointer !important; background: #f8f9fa !important; border: 1px solid #e9ecef !important; margin-bottom: 8px !important; width: 100% !important; min-height: 48px !important; text-align: center !important; padding: 8px 4px !important; }
  .cwd-type-pill.selected { background: #0048B3 !important; border-color: #0048B3 !important; box-shadow: 0 2px 8px rgba(0,72,179,0.3) !important; }
  .cwd-type-pill-text { font-size: 14px !important; font-weight: 400 !important; color: #212427 !important; font-family: 'Poppins', sans-serif !important; }
  .cwd-type-pill.selected .cwd-type-pill-text { color: white !important; font-weight: 500 !important; }
`

interface CarWithDriverCarTypeModalProps {
  open: boolean
  selectedType: string
  onSelect: (type: string) => void
  onClose: () => void
}

const CarWithDriverCarTypeModal: React.FC<CarWithDriverCarTypeModalProps> = ({
  open,
  selectedType,
  onSelect,
  onClose,
}) => {
  const { t } = useCwdLang()
  return (
    <>
      <style>{modalStyles}</style>
      <Modal
        centered
        title={t.common.carType}
        open={open}
        onCancel={onClose}
        footer={null}
        width={490}
        className="cwd-type-modal"
        destroyOnClose
      >
        <Row gutter={[8, 0]}>
          {CAR_TYPES.map(({ label }) => (
            <Col span={8} key={label}>
              <div
                className={`cwd-type-pill ${selectedType === label ? 'selected' : ''}`}
                onClick={() => {
                  onSelect(label)
                  onClose()
                }}
              >
                <div className="cwd-type-pill-text">{label}</div>
              </div>
            </Col>
          ))}
        </Row>
      </Modal>
    </>
  )
}

export default CarWithDriverCarTypeModal
